import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import Dot from "@Front/Components/Layouts/Legal/LegalInformations/elements/Dot";
import LinkInline from "../../elements/LinkInline";
import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";

export function RightToInformationIntro(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TEXT_LG_SEMIBOLD} color={ETypoColor.TEXT_SECONDARY}>
				Droit à l&apos;information
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Vous pouvez exercer vos droits par voie électronique à l&apos;adresse suivante ({pub.contactEmail}) ou par courrier postal à
				l&apos;adresse {pub.publisherLegalName} - {pub.postalAddressLine}, en justifiant de votre identité.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Si nous décidons de traiter des données pour des finalités autres que celles indiquées, toutes les informations relatives à
				ces nouvelles finalités vous seront communiquées.
			</Typography>
		</>
	);
}

export function RightToAccessHeading(): React.JSX.Element {
	return (
		<Typography typo={ETypo.TEXT_LG_SEMIBOLD} color={ETypoColor.TEXT_SECONDARY}>
			Droit d&apos;accès et à la rectification de vos données
		</Typography>
	);
}

export function RightToAccessIntro(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	const mailHref = `mailto:${pub.contactEmail}`;
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Vous disposez du droit d&apos;accéder et de faire rectifier vos données personnelles, que vous pouvez exercer auprès de {pub.publisherLegalName}
				par voie électronique à l&apos;adresse
				<LinkInline text={pub.contactEmail} href={mailHref} />
				ou par courrier postal à l&apos;adresse {pub.publisherLegalName} – {pub.postalAddressLine}.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				A ce titre, vous avez la confirmation que vos données personnelles sont ou ne sont pas traitées et lorsqu&apos;elles le sont, et
				disposez de l&apos;accès à vos données ainsi qu&apos;aux informations concernant :
			</Typography>
		</>
	);
}

export function RightToAccessDotList(): React.JSX.Element {
	return (
		<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
			<Dot>les finalités du traitement ;</Dot>
			<Dot>les catégories de données personnelles concernées ;</Dot>
			<Dot>
				les destinataires ou catégories de destinataires ainsi que les organisations internationales auxquels les données
				personnelles ont été ou seront communiquées, en particulier les destinataires qui sont établis dans des pays tiers ;
			</Dot>
			<Dot>
				lorsque cela est possible, la durée de conservation des données personnelles envisagée ou, lorsque ce n&apos;est pas possible,
				les critères utilisés pour déterminer cette durée ;
			</Dot>
			<Dot>
				l&apos;existence du droit de demander au responsable du traitement la rectification ou l&apos;effacement de vos données personnelles,
				du droit de demander une limitation du traitement de vos données personnelles, du droit de vous opposer à ce traitement ;
			</Dot>
			<Dot>le droit d&apos;introduire une réclamation auprès d&apos;une autorité de contrôle ;</Dot>
			<Dot>
				des informations relatives à la source des données quand elles ne sont pas collectées directement auprès des personnes
				concernées ;
			</Dot>
			<Dot>
				l&apos;existence d&apos;une prise de décision automatisée, y compris de profilage, et dans ce dernier cas, des informations utiles
				concernant la logique sous-jacente, ainsi que l&apos;importance et les conséquences prévues de ce traitement pour les personnes
				concernées.
			</Dot>
		</Typography>
	);
}

export function RightToAccessClosing(): React.JSX.Element {
	return (
		<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
			Vous pouvez nous demander que vos données personnelles soient, selon les cas, rectifiées, complétées si elles sont inexactes,
			incomplètes, équivoques, périmées.
		</Typography>
	);
}
